var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4401 10.2933L4.85339 48C4.3877 48.8065 4.1413 49.7208 4.13869 50.6521C4.13609 51.5833 4.37736 52.499 4.83853 53.3081C5.29969 54.1171 5.96466 54.7913 6.76728 55.2636C7.5699 55.7359 8.48219 55.9898 9.41339 56H54.5867C55.5179 55.9898 56.4302 55.7359 57.2328 55.2636C58.0355 54.7913 58.7004 54.1171 59.1616 53.3081C59.6227 52.499 59.864 51.5833 59.8614 50.6521C59.8588 49.7208 59.6124 48.8065 59.1467 48L36.5601 10.2933C36.0847 9.50961 35.4153 8.86165 34.6166 8.41195C33.8178 7.96226 32.9167 7.72601 32.0001 7.72601C31.0834 7.72601 30.1823 7.96226 29.3835 8.41195C28.5848 8.86165 27.9154 9.50961 27.4401 10.2933V10.2933Z",
    stroke: "#D12335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18V36",
    stroke: "#DE3C4B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45.3334H32.0259",
    stroke: "#DE3C4B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadError);
export default __webpack_public_path__ + "static/media/upload-error.26b3df0e552772d34defd54a73bb6645.svg";
export { ForwardRef as ReactComponent };